<template>
  <div
    v-if="!computedHide"
    class="select-element"
    :class="{disabled: computedDisabled}"
  >
    <h4
      v-if="title"
      class="g-title g-title--subtitle"
    >
      {{ title }}
    </h4>
    <div class="select-element-wrapper">
      <select
        v-model="modifiedValue"
        class="g-btn g-btn--rounded g-btn--select"
        :disabled="computedDisabled"
        :class="{disabled: computedDisabled}"
        @change="returnText($event)"
      >
        <option
          disabled
          value=""
        >
          {{ defaultText ? defaultText : $t('messages.sharedTexts.placeholders.pleaseSelectOne') }}
        </option>
        <option
          v-for="(listItem, index) in list"
          :key=" index"
          :value="listItem.value"
          :selected="value == listItem.value ? 'selected' : ''"
          :disabled="listItem.disabled"
        >
          {{ listItem.icon }} {{ listItem.label }}
        </option>
      </select>
      <font-awesome-icon :icon="['fas', 'chevron-down']" />
    </div>
  </div>
</template>

<script>
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

export default {
  name: 'SelectElementReactive',
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number, Object, null, undefined],
      default: undefined
    },
    defaultText: {
      type: String,
      default: ''
    },
    emitFunctionNamed: { // Legacy @TODO: refactor remove
      type: String,
      default: ''
    },
    list: {
      type: [Array, null],
      default: null
    },
    hide: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modifiedValue: null,
      modifiedList: null
    }
  },
  computed: {
    computedDisabled() {
      if(!Array.isArray(this.modifiedList)) return true

      const onlyOneAndSelected = this.modifiedList.length === 1 && this.list[0].value === this.modifiedValue
      return this.disabled|| this.list.length === 0 || onlyOneAndSelected
    },
    computedHide() {
      return this.list === undefined || this.value === undefined || this.list === null || this.hide === true
    }
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        this.modifiedValue = newValue === undefined ? oldValue : newValue
      },
      immediate: true
    },
    list: {
      handler(newValue, oldValue) {
        this.modifiedList = newValue || oldValue
      },
      immediate: true
    }
  },
  methods: {
    reset() {
      this.modifiedValue = this.value
    },
    returnText(e) {
      this.$emit(this.emitFunctionNamed || 'change', this.modifiedList.find((item) => item.value === this.modifiedValue))
    }
  }
}
</script>

<style lang="scss">
  .select-element {
    display: inline-block;

    select {
      text-overflow: ellipsis;
      padding-right: 20px;
    }

    &.disabled {
      .svg-inline--fa {
        color: $color-grey !important;
      }
    }

    &--full {
      width: 100%;
      .select-element-wrapper {
        width: 100%;
        select {
          width: 100%;
          height: 38px;
          margin: 10px 0px;
        }
      }
    }

    .select-element-wrapper {
      position: relative;
      display: inline-flex;
      align-items: center;
      margin: 10px 0;
    }

    .svg-inline--fa {
      pointer-events: none;
    }
  }
</style>
